/*
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

export function setScriptSrc(script: HTMLScriptElement, src: string) {
  script.src = src;
}
